import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    sidebarOpen  : true,
    mobileSidebar: false,
    theme        : localStorage.getItem('theme') || 'light',
  },
  reducers: {
    toggleSidebar    : (s) => { s.sidebarOpen   = !s.sidebarOpen; },
    setMobileSidebar : (s, { payload }) => { s.mobileSidebar = payload; },
    setTheme         : (s, { payload }) => {
      s.theme = payload;
      localStorage.setItem('theme', payload);
      document.documentElement.classList.toggle('dark', payload === 'dark');
    },
  },
});

export const { toggleSidebar, setMobileSidebar, setTheme } = uiSlice.actions;
export default uiSlice.reducer;
